import { useUsage } from "../../contexts/UsageContext";
import { BarChart3 } from "lucide-react";

export function UsageIndicator() {
  const { usage, isLoading, hasSubscription } = useUsage();

  if (isLoading || !hasSubscription || !usage) return null;

  const percentage = Math.round((usage.remaining / usage.limit) * 100);
  const label = usage.metering_mode === "chats" ? "conversations" : "messages";
  const resetDate = new Date(usage.period_end).toLocaleDateString("fr-CA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  let colorClass = "bg-green-500";
  let textColorClass = "text-green-400";
  if (percentage <= 20) {
    colorClass = "bg-red-500";
    textColorClass = "text-red-400";
  } else if (percentage <= 50) {
    colorClass = "bg-yellow-500";
    textColorClass = "text-yellow-400";
  }

  return (
    <div className="px-4 py-3">
      <div className="flex items-center gap-2 mb-1">
        <BarChart3 className={`w-4 h-4 ${textColorClass}`} />
        <span className="text-xs text-gray-300">
          {usage.remaining} / {usage.limit} {label} restants
        </span>
      </div>
      <div className="w-full bg-gray-700 rounded-full h-1.5 mb-1.5">
        <div
          className={`h-1.5 rounded-full ${colorClass} transition-all`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="text-[10px] text-gray-400">
        Votre utilisation se réinitialise le {resetDate}
      </p>
    </div>
  );
}
